/**
 * Staging / non-production builds: match robots meta in App.js.
 * When true, do not emit JSON-LD (structured data is for the public main domain only).
 */
export function isSearchIndexingBlocked(): boolean {
  return (
    String(process.env.REACT_APP_BLOCK_SEARCH_INDEXING || "")
      .toLowerCase()
      .trim() === "true"
  );
}
